import {Container, Col, Row }from 'react-bootstrap';

import Header from '../sections/header';
import Footer from '../sections/footer';
import MainContent from '../sections/maincontent';
import SplashImage from '../gridspaces/splashimage';


function PageAudience(){
    return (
        <> 
            <Header />
            <Container fluid className="color-bg-secondary">
                    <MainContent>
                        <Row className="">
                            <SplashImage image="/assets/skylinesplash.jpg" />
                        </Row>
                        <Row className="color-bg-primary">
                            <Col md={{span: 6, offset: 3}}>
                            <p className="text-start font-body font-size-large">We Provide Premier Service</p>
                            <p className="text-start font-body font-size-mediuam">We partner with brands, individuals, and companies that serve and engage with the active lifestyle communities. Whether it is weekend warriors training for their first races or an emerging business looking to promote itself at a post-race party, nothing is too small or too complex. We understand the unique dynamics of the active community and offer our experience in service to industries that cater to it.</p>
                            </Col>
                        </Row>                  
                    </MainContent>
            </Container>
            <Footer />
        </>
    )
}

export default PageAudience;